/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.ai.rpc.CatalogItemRecommendationRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getSimilarItemsRpc = {
  serviceName: 'com.hubspot.academy.ai.rpc.CatalogItemRecommendationRpc',
  rpcName: 'getSimilarItems',
  auth: 'app',
  fingerprint: 'UPuf-eH1SUGuC5P1LA5xQ5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};